import { render, staticRenderFns } from "./listaAtendimento.vue?vue&type=template&id=1fb9a85a&scoped=true&"
import script from "./listaAtendimento.vue?vue&type=script&lang=js&"
export * from "./listaAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./listaAtendimento.vue?vue&type=style&index=0&id=1fb9a85a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb9a85a",
  null
  
)

export default component.exports